import Keycloak from 'keycloak-js';

const authStaging = {
  auth_url: 'https://id.skunkworks.ai/auth',
  realm: 'staging',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: '4539fb05-ba4a-4f69-b43b-75b6a48691d9',
  powerBIGroupID: ' 13834247-2464-49f5-b013-b35c254e090a',
  superset: {
    baseUrl: 'https://superset-staging.internal.viana.ai',
    trafficMeasurement: 'a54b1bd7-28c7-41c8-a2d2-eb1b9d736f9f',
    peopleCounting: 'e25e3117-d78f-4f06-8935-54131b9081b7',
    red: {
      red: '9c97fef0-0445-40ad-bc79-03303311988f',
      red_pg: '42a412be-a9e8-4d04-9504-ae613444e2be',
      red_classic: 'aec84134-08c0-43b7-a927-befc5f0c87cc',
      red_basic: '6bdefc37-d62d-46a2-abbe-d6b99cff51dc',
      red_gamma: '9c97fef0-0445-40ad-bc79-03303311988f',
      red_zeta: '42a412be-a9e8-4d04-9504-ae613444e2be',
      red_sos: 'c1e13f65-b4bd-4322-8f6a-75dda5bd51c8',
    },
    aam: {
      default: '7e57babf-64f0-4607-9611-cb047bd6aa11',
    },
    samdt: {
      default: '0fa6946f-99a9-4174-8c10-32c103e98ca0',
      meldcx: '8561a007-eec0-491d-b945-01254ee6ba2c',
    },
    shelfEngagement: 'a6e93268-0917-4f0f-bb1e-c55a04ce7c20',
    partnerOps: 'e74ea3e3-5b52-49f5-906a-87830f96a21f',
    sos: 'd588b395-01e2-4a7c-b2b4-1200796735a7',
  }
};

const endpointsStaging = {
  environment: 'staging',
  base_url: 'https://staging.services.api.viana.ai/',
  base_url_insights: 'https://staging.insights.api.viana.ai/',
  admin_url: 'https://staging.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: 'https://0fff9f661ea047f683b1113a7fcc80bd@sentry.internal.viana.ai/8'
};

const endpointsStaging2 = {
  environment: 'staging2',
  base_url: 'https://viana-services-staging-copy2.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-staging-stage.azurewebsites.net/',
  admin_url: 'https://staging.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const endpointsStaging4 = {
  environment: 'staging4',
  // base_url: 'https://viana-services-staging-copy3.azurewebsites.net/',
  // base_url: 'https://viana-services-n16-staging-svc-staging4.azurewebsites.net/',
  // base_url_insights: 'https://viana-insights-n16-staging-svc-copy4.azurewebsites.net/',
  // base_url_insights: 'https://viana-insights-staging-auspost.azurewebsites.net/',
  base_url: 'https://viana-services-n16-staging-svc-staging4.azurewebsites.net/',
  base_url_insights: 'https://staging.insights.api.viana.ai/',
  admin_url: 'https://admin.node16poc.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const endpointsVersaDev = {
  environment: 'versa_dev',
  base_url: 'https://versa-services-dev-svc.azurewebsites.net/',
  base_url_insights: 'https://versa-insights-dev-svc.azurewebsites.net/',
  admin_url: 'https://staging.admin.internal.viana.ai/'
};

const endpointsVersaStaging = {
  environment: 'versa_staging',
  base_url: 'https://versa-services-staging-svc.azurewebsites.net/',
  base_url_insights: 'https://versa-insights-staging-svc.azurewebsites.net/',
  admin_url: 'https://staging.admin.internal.viana.ai/'
};

const endpointsVianaLite = {
  environment: 'viana_lite_internal',
  base_url: 'https://viana-internal-services-staging-svc.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-staging.azurewebsites.net/',
  admin_url: 'https://staging.admin.internal.viana.ai/'
};

const endpointsVianaLitePreproduction = {
  environment: 'viana_lite_internal_preproduction',
  base_url: 'https://viana-internal-services-ppd-svc.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-preprod.azurewebsites.net/',
  admin_url: 'https://prep.admin.internal.viana.ai/'
};

const authDev = {
  auth_url: 'https://id.skunkworks.ai/auth',
  realm: 'staging',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: '4539fb05-ba4a-4f69-b43b-75b6a48691d9',
  powerBIGroupID: ' 13834247-2464-49f5-b013-b35c254e090a',
  superset: {
    baseUrl: 'https://superset-dev.internal.viana.ai',
    trafficMeasurement: '344fea4a-b496-474c-a21d-ba54fed81c7b',
    red: {
      red: '1fa0b4cd-7179-463f-b8fc-05f3133bb8fe',
      red_pg: '',
      red_classic: '',
      red_basic: '',
      red_gamma: '',
      red_zeta: '1fa0b4cd-7179-463f-b8fc-05f3133bb8fe',
      red_sos: '',
    },
    samli: '5d57aa6d-7a6a-4859-b58a-8090203fe5b2',
    samdt: {
      default: '9fab0aaa-d6a9-406d-b54e-07a1e50b2e75',
      meldcx: '9fab0aaa-d6a9-406d-b54e-07a1e50b2e75',
    },
    aam: {
      default: 'f6f91b91-ae1a-41c7-992c-896dbf960574',
      vehicle: '1603ad3c-6b81-45f8-92c6-0dbd56be64e5'
    },
    shelfEngagement: 'd71f6575-89ef-4ee6-8d76-45fe99abe382',
    partnerOps: '7c67fa93-404e-41a1-a6cc-007047c23960',
    peopleCounting: '8d1cbca4-2900-4a48-accf-5963050502fd',
    sos: '4eac8732-079b-403e-9013-51637f4fcb1e',
  }
};

const endpointsDev = {
  environment: 'dev',
  base_url: 'https://dev.services.api.viana.ai/',
  base_url_insights: 'https://dev.insights.api.viana.ai/',
  admin_url: 'https://dev.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  // sentry_dsn: 'https://3c84de2cf4ef48c8b81d9959fa173ad3@sentry.internal.viana.ai/7'
};

const endpointsNode16Dev = {
  environment: 'node16_dev',
  base_url: 'https://services.node16poc.internal.viana.ai/',
  base_url_insights: 'https://insights.node16poc.internal.viana.ai/',
  admin_url: 'https://admin.node16poc.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const endpointsDev2 = {
  environment: 'dev2',
  base_url:'https://dev2.services.api.viana.ai/',
  base_url_insights: 'https://dev2.insights.api.viana.ai/',
  admin_url: 'https://dev.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const endpointsDev3 = {
  environment: 'dev3',
  base_url: 'https://viana-dev-copy3.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-dev-copy2.azurewebsites.net/',
  admin_url: 'https://dev.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const endpointsDev4 = {
  environment: 'dev4',
  base_url: 'https://viana-dev-copy4.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-dev.azurewebsites.net/',
  admin_url: 'https://dev.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const endpointsPerduePreproduction = {
  environment: 'perdue_ppd',
  base_url: 'https://viana-services-preprod-2.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-preprod-perdue.azurewebsites.net/',
  admin_url: 'https://prep.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: 'https://87eb9ff084514f84984d79fc2ceb39c2@sentry.internal.viana.ai/9'
};

// const authPreproduction = {
//   auth_url: 'https://id.skunkworks.ai/auth',
//   realm: 'preprod',
//   access_token_url: 'https://id.skunkworks.ai/auth/realms/preprod/protocol/openid-connect/token',
//   client_id: 'viana-portal',
//   scope: 'openid user',
//   powerBIReportID: 'cd127ee8-e16b-4f83-8fae-2d096d07ab77',
//   powerBIGroupID: '1aa87852-3472-4e22-b260-796f0e301f33',
//   superset: {
//     baseUrl: 'https://superset-ppd.internal.viana.ai',
//     red: {
//       red: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
//       red_pg: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
//       red_classic: '440facd3-4db8-47c3-9fc7-94f802c567a4',
//       red_basic: '80cdacce-05bb-4433-aa1b-13efccf1dba8',
//       red_gamma: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
//       red_zeta: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
//       red_sos: 'b4641746-d612-40c1-b88d-e3ae68f0c32d',
//     },
//     peopleCounting: '366e139b-418e-445e-9362-e5efc8998028',
//     trafficMeasurement: '0ab91b9d-c18b-472b-b4be-6c2400ef9a85',
//     aam: '02c868f8-98f1-4129-ba26-7bcfd4d247c5',
//     samli: 'f401eee8-e4f0-4071-9420-1f41081cf4ce',
//     samdt: {
//       default: '305bd351-f335-46dd-bc4c-ae6ddc95cc19',
//       meldcx: 'ee4bebbf-bf1b-4c36-b183-4e88bdd861b1',
//     },
//     partnerOps: 'aceea188-7c56-47a8-bb61-2866038cb40c',
//   }
// };

const authPreproduction = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'preprod',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/preprod/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: 'cd127ee8-e16b-4f83-8fae-2d096d07ab77',
  powerBIGroupID: '1aa87852-3472-4e22-b260-796f0e301f33',
  superset: {
    baseUrl: 'https://ppd-gcp.superset.internal.viana.ai',
    red: {
      red: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
      red_pg: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
      red_classic: '569015da-7383-4a12-802e-0e33c16c1ac4',
      red_basic: '80cdacce-05bb-4433-aa1b-13efccf1dba8',
      red_gamma: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
      red_zeta: 'b4dc7fe1-ffff-432a-98cb-0384845ef051',
      red_sos: 'b4641746-d612-40c1-b88d-e3ae68f0c32d',
      red_meldcx: '569015da-7383-4a12-802e-0e33c16c1ac4',
    },
    peopleCounting: '366e139b-418e-445e-9362-e5efc8998028',
    trafficMeasurement: '0ab91b9d-c18b-472b-b4be-6c2400ef9a85',
    aam: {
      default: '',
      vehicle: '',
      meldcx: 'ed175eca-734d-4d94-9bf5-8c993ac7c979',
      qic: 'ed175eca-734d-4d94-9bf5-8c993ac7c979',
    },
    samli: '',
    samdt: {
      default: '305bd351-f335-46dd-bc4c-ae6ddc95cc19',
      meldcx: '41cc6626-963a-4d6e-96f3-8fdd3fe5f98e',
    },
    partnerOps: {
      default: '',
      starbucksph: '',
      pg: '',
      meldcx: 'aceea188-7c56-47a8-bb61-2866038cb40c',
    },
    sos: 'a94e2a72-578f-460f-bc88-4b86bc87fff2',
    shelfEngagement: 'a472bf28-4a3a-4242-b81c-254851fc66cb',
  }
};

// const endpointsPreproduction = {
//   environment: 'preproduction',
//   base_url: 'https://ppd.services.api.viana.ai/',
//   base_url_insights: 'https://ppd.insights.api.viana.ai/',
//   admin_url: 'https://prep.admin.internal.viana.ai/',
//   assets_url: 'https://assets.api.viana.ai/',
//   sentry_dsn: 'https://ddb5c9f286f842168168f35734d27f3c@sentry.internal.viana.ai/10'
// };

const endpointsPreproduction = {
  environment: 'preproduction',
  base_url: 'https://crn-viana-ppd-ausse2-aiservices-939112729767.australia-southeast2.run.app/',
  base_url_insights: 'https://crn-viana-ppd-ausse2-aiinsights-939112729767.australia-southeast2.run.app/',
  admin_url: 'https://ppd-gcp.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: 'https://ddb5c9f286f842168168f35734d27f3c@sentry.internal.viana.ai/10',
  firebase_config: {
    apiKey: "AIzaSyCEm5xiDbyOQ_X0zjLAIDPui1nqQCI3PKI",
    authDomain: "prj-pre-prod-srv-viana-a1.firebaseapp.com",
    projectId: "prj-pre-prod-srv-viana-a1",
    storageBucket: "prj-pre-prod-srv-viana-a1.firebasestorage.app",
    messagingSenderId: "939112729767",
    appId: "1:939112729767:web:73433dc6a067d568e29f82"
  },
};

const endpointsNespressoPreproduction = {
  environment: 'nespresso_ppd',
  base_url: 'https://viana-services-preprod-2-nespresso.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-preprod-nespresso.azurewebsites.net/',
  admin_url: 'https://nespresso.prep.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: 'https://ddb5c9f286f842168168f35734d27f3c@sentry.internal.viana.ai/10'
};

// const authProduction = {
//   auth_url: 'https://id.viana.ai/auth',
//   realm: 'production',
//   access_token_url: 'https://id.viana.ai/auth/realms/production/protocol/openid-connect/token',
//   client_id: 'viana-portal',
//   scope: 'openid user',
//   powerBIReportID: 'f105c699-f9b4-49db-8c81-0b31179d8429',
//   powerBIGroupID: '75816e02-3bb5-479b-9b13-c5232ba9bbe1',
//   superset: {
//     baseUrl: 'https://cortex2.viana.ai',
//     samdt: {
//       default: '480e4563-ea4a-4e49-80a6-3ad37b9b8371',
//       samdt_meldcx: '5cf52fb0-6f50-43b0-a1db-60660b5e9505',
//       meldcx: '5cf52fb0-6f50-43b0-a1db-60660b5e9505',
//       pg: '63894c31-907d-432d-9943-9d97bde61307',
//       starbucksph: '2b18fbf7-1153-4776-be3a-5443e7aceba2',
//       starbucks: '19bff512-73ed-4452-8f26-0052faadd72e',
//       wendys: 'e0a2e98c-77fc-4dd5-b9a3-fc25823410e4',
//     },
//     red: {
//       red: '0c58aa37-398f-4dee-a0e3-3ea3ad4cc743',
//       red_pg: '5f1b0d77-0040-4582-aa74-ca9b7a71c511',
//       red_classic: '0c58aa37-398f-4dee-a0e3-3ea3ad4cc743',
//       red_basic: '6902b044-2072-4a37-968d-6f3606984910',
//       red_gamma: '8e8db710-2734-438e-a0cb-f1585638e9f9',
//       red_zeta: '8e8db710-2734-438e-a0cb-f1585638e9f9',
//       red_sos: '3f25386e-6860-4991-ab9b-380b9fde9bc2',
//     },
//     peopleCounting: '5ac1d70a-bb96-4c38-b0e6-29b8e3f94be8',
//     trafficMeasurement: '3a55a582-1373-449c-b2f7-f42315726363',
//     aam: {
//       default: '0528d3c5-28f9-47d2-bd14-8467dc0cbdbd',
//       meldcx: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
//       aircads: 'ca47e984-474e-4f43-9843-b87f16d377bc',
//       qic: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
//       indosat: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
//       pg: '0528d3c5-28f9-47d2-bd14-8467dc0cbdbd',
//       manwharf: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
//       glasscast: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
//     },
//     samli: 'ba4945b6-9885-4eb4-8864-f67b05281ef6',
//     partnerOps: {
//       default: 'ab71c534-44e4-4eb9-b680-ab1d58cb76f4',
//       starbucksph: 'e4b2cc69-00c8-420e-8408-60039f15b42f',
//       pg: 'c02d5f3c-b73b-4008-aa5c-5533a00cc9ea',
//       meldcx: 'fd9796e2-2025-4b97-9184-619293a1488d',
//       meldcxph: '77b37ea4-c64b-4fa1-bcf8-ceb30685b9d0',
//     },
//     sos: 'ad317ff3-94fe-4f66-85dd-12e4f862d4bf',
//   }
// };

const authProduction = {
  auth_url: 'https://prod-gcp.id2.viana.ai/auth',
  realm: 'production',
  access_token_url: 'https://prod-gcp.id2.viana.ai/auth/realms/production/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: 'f105c699-f9b4-49db-8c81-0b31179d8429',
  powerBIGroupID: '75816e02-3bb5-479b-9b13-c5232ba9bbe1',
  superset: {
    baseUrl: 'https://prod-gcp.xray.viana.ai',
    samdt: {
      default: '480e4563-ea4a-4e49-80a6-3ad37b9b8371',
      samdt_meldcx: '5cf52fb0-6f50-43b0-a1db-60660b5e9505',
      meldcx: 'cc4bd851-955e-44f3-9d51-33fe105c1e7b',
      pg: '0306e355-fa0c-4436-b591-e98b013fd6d1',
      starbucksph: '2b18fbf7-1153-4776-be3a-5443e7aceba2',
      starbucks: '19bff512-73ed-4452-8f26-0052faadd72e',
      wendys: 'e0a2e98c-77fc-4dd5-b9a3-fc25823410e4',
    },
    red: {
      red: '0c58aa37-398f-4dee-a0e3-3ea3ad4cc743',
      red_pg: '5f1b0d77-0040-4582-aa74-ca9b7a71c511',
      red_classic: '0c58aa37-398f-4dee-a0e3-3ea3ad4cc743',
      red_basic: '6902b044-2072-4a37-968d-6f3606984910',
      red_gamma: '8e8db710-2734-438e-a0cb-f1585638e9f9',
      red_zeta: '8e8db710-2734-438e-a0cb-f1585638e9f9',
      red_sos: '3f25386e-6860-4991-ab9b-380b9fde9bc2',
      red_meldcx: 'a8c92c8e-fef7-4bf9-b02b-35784d502fbd',
      red_truis: '8e8db710-2734-438e-a0cb-f1585638e9f9',
      red_innov: '02147caf-ebaa-44a9-980f-e02ca36f0ce8',
      red_derode: 'cc6d17bf-236f-4f55-acb3-42d72fb7bed1',
      red_krispyuk: '773cb43c-4494-41dd-b9cd-19ddd6a84774',
      red_brepbrew: 'c329b1ac-47c3-48f0-af5e-e2702a1a7eb0',   // gamma
      red_axis: 'bf0f5b0b-287a-4b75-be97-4c6db2150970',   // gamma
      red_cisilion: '96182290-7c60-400a-8bfd-6178591ac412',   // gamma
      red_indosat: 'b6bc9d5b-adda-4cd3-9613-bcda67e1841a',   // gamma
    },
    peopleCounting: '5ac1d70a-bb96-4c38-b0e6-29b8e3f94be8',
    trafficMeasurement: {
      default: '6bf39055-09b2-456c-97fc-9b50ef0cc59b',
      aom: '00590c5a-117e-4ab7-b79f-77ada5b38fa5',
      pg: '13295798-b14d-48df-b862-492ca111a5c2',
      stride: '3be1a6b8-ea44-4f5f-a44b-f8058241ea3e',
    },
    aam: {
      default: '0528d3c5-28f9-47d2-bd14-8467dc0cbdbd',
      meldcx: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      aircads: 'ca47e984-474e-4f43-9843-b87f16d377bc',
      qic: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      indosat: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      pg: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      manwharf: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      glasscast: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      truis: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      brepublic: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      dp: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
      ritchies: '8603a68c-2dbe-46fd-a72e-d71f0c8e9af3',
    },
    samli: 'ba4945b6-9885-4eb4-8864-f67b05281ef6',
    partnerOps: {
      default: 'ab71c534-44e4-4eb9-b680-ab1d58cb76f4',
      starbucksph: 'e4b2cc69-00c8-420e-8408-60039f15b42f',
      pg: 'c02d5f3c-b73b-4008-aa5c-5533a00cc9ea',
      meldcx: 'e3532ad9-b474-4741-a9d6-4037981db94b',
      meldcxph: '77b37ea4-c64b-4fa1-bcf8-ceb30685b9d0',
    },
    sos: {
      default: 'ad317ff3-94fe-4f66-85dd-12e4f862d4bf',
      pg: '608e08c9-af98-437f-b3d0-6c788937b43e',
    },
  },
  superset2: {
    baseUrl: 'https://v2-gcp.superset.internal.viana.ai/',
    aam: {
      default: '',
      vehicle: '',
      meldcx: 'b7a5e61f-e573-4236-857f-4cca5264840b',
      bsign: '4fed495d-a339-4aba-ad69-d7576eb309f1',
    },
  }
};

// const endpointsProduction = {
//   environment: 'production',
//   base_url: 'https://services.api.viana.ai/',
//   //base_url: 'https://viana-services-n16-production.azurewebsites.net/',
//   base_url_insights: 'https://insights.api.viana.ai/',
//   admin_url: 'https://admin.viana.ai/',
//   assets_url: 'https://assets.api.viana.ai/',
//   sentry_dsn: ''
// };

const endpointsProduction = {
  environment: 'production',
  base_url: 'https://prod-gcp.services.api.viana.ai/',
  base_url_insights: 'https://prod-gcp.insights.api.viana.ai/',
  admin_url: 'https://prod-gcp.admin.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: '',
  firebase_config: {
    apiKey: "AIzaSyBt72fQ2h_NaX4aaIcIsOEzcE3WtZTUIzw",
    authDomain: "prj-prod-svc-viana-15.firebaseapp.com",
    projectId: "prj-prod-svc-viana-15",
    storageBucket: "prj-prod-svc-viana-15.firebasestorage.app",
    messagingSenderId: "921647284908",
    appId: "1:921647284908:web:3cf45bc5d37f4538165509"
  }
};

const endpointsProd2 = {
  environment: 'prod2',
  base_url: 'https://viana-services-production-prod2.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-production2-prod2.azurewebsites.net/',
  admin_url: 'https://admin.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: 'https://ef2e4e96c0b043fe905a8a932eefbddf@sentry.internal.viana.ai/20'
};

const authOptus = {
  auth_url: 'https://id.viana.ai/auth',
  realm: 'production',
  access_token_url: 'https://id.viana.ai/auth/realms/production/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: 'fd4a155b-f344-439f-9880-2ec21f6358aa',
  powerBIGroupID: 'a9b83148-febd-4493-a7d3-8d6e04b80180',
  yellowfin: {
    baseUrl: 'https://apac-poc.yellowfin.bi',
    peopleCounting: 'c41091eb-58b0-4628-b736-53e30c03b7c8',
    posCorrelation: 'd75f7c86-60c8-45d6-9d1d-ef1412e25fb6',
    productEngagement: '0ca58bc8-8058-4ea7-a3ef-bdc1e9ee207e',
    shelfEngagement: '95c55df6-7830-45f7-9aaf-03dcc21366b7',
    zoneEngagement: '7f60be6e-d6d5-4a64-b7a9-b4a5a31e8ac0',
    trafficMeasurement: '88dd3c49-62c5-4bcd-aff2-1c0bcf808500',
    aam: 'b0dc435c-870f-4b9e-b2d3-1ba409435769',
    coffee: '72297534-7197-4390-b4d1-61eba51ddb36',
    samie: '9d458d9d-76c3-417e-97f3-248b99bc6d0b',
  }
};

const endpointsOptus = {
  environment: 'optus',
  base_url: 'https://optus.services.api.viana.ai/',
  base_url_insights: 'https://optus.insights.api.viana.ai/',
  admin_url: 'https://optus.admin.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const authPCStaging = {
  auth_url: 'https://id.skunkworks.ai/auth',
  realm: 'staging',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: '4539fb05-ba4a-4f69-b43b-75b6a48691d9',
  powerBIGroupID: ' 13834247-2464-49f5-b013-b35c254e090a',
  yellowfin: {
    baseUrl: 'https://apac-poc.yellowfin.bi',
    peopleCounting: 'c41091eb-58b0-4628-b736-53e30c03b7c8',
    posCorrelation: 'd75f7c86-60c8-45d6-9d1d-ef1412e25fb6',
    productEngagement: '0ca58bc8-8058-4ea7-a3ef-bdc1e9ee207e',
    shelfEngagement: '95c55df6-7830-45f7-9aaf-03dcc21366b7',
    zoneEngagement: '7f60be6e-d6d5-4a64-b7a9-b4a5a31e8ac0',
    trafficMeasurement: '33932758-58d5-4b27-942d-9b910a928874',
    aam: '6e1babb3-4e7f-4f70-9754-78f00cd90f7e',
    coffee: '72297534-7197-4390-b4d1-61eba51ddb36',
    samie: '9d458d9d-76c3-417e-97f3-248b99bc6d0b',
  }
};

const endpointsPCStaging = {
  environment: 'pc-staging',
  base_url: 'https://viana-dev.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-dev.azurewebsites.net/',
  admin_url: 'https://staging.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/'
};

const endpointsLocal = {
  environment: 'local',
  base_url: 'http://localhost:3000/',
  base_url_insights: 'http://localhost:4000/',
  admin_url: 'https://dev.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
};


const authDevGCP = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: '4539fb05-ba4a-4f69-b43b-75b6a48691d9',
  powerBIGroupID: ' 13834247-2464-49f5-b013-b35c254e090a',
  superset: {
    baseUrl: 'https://dev-gcp.superset.internal.viana.ai',
    trafficMeasurement: '344fea4a-b496-474c-a21d-ba54fed81c7b',
    red: {
      default: '',
      red_pg: '',
      red_classic: 'efdd7f80-31b5-4fbb-941e-ae7f52babd09',
      red_basic: '',
      red_gamma: '',
      red_zeta: '1fa0b4cd-7179-463f-b8fc-05f3133bb8fe',
      red_sos: '',
      red_meldcx: 'f9c411ef-3bea-4f0a-9a51-5ae40896125e',
    },
    samli: '5d57aa6d-7a6a-4859-b58a-8090203fe5b2',
    samdt: {
      default: '9fab0aaa-d6a9-406d-b54e-07a1e50b2e75',
      meldcx: 'bba8357f-6020-40ce-b4b0-771640b15917',
    },
    aam: {
      default: '',
      vehicle: '1603ad3c-6b81-45f8-92c6-0dbd56be64e5',
      meldcx: '009631f2-d00b-4d47-ad85-829ecd3be605',
    },
    shelfEngagement: 'd71f6575-89ef-4ee6-8d76-45fe99abe382',
    partnerOps: {
      default: 'f2f28926-dce0-4472-a298-96bbc1753b8a',
      starbucksph: '',
      pg: '',
    },
    peopleCounting: '24d71243-1824-4674-bb56-34da1fbb91e2',
    sos: 'adc1901c-71c8-47b1-a2cb-17a764fc0afe',
    prodHopTracking: '9f1177e6-e9f9-4af1-a1b5-6afc70169758',
  }
};

const authDevGCP2 = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: '4539fb05-ba4a-4f69-b43b-75b6a48691d9',
  powerBIGroupID: ' 13834247-2464-49f5-b013-b35c254e090a',
  superset: {
    baseUrl: 'https://dev-gcp.superset.internal.viana.ai',
    trafficMeasurement: '344fea4a-b496-474c-a21d-ba54fed81c7b',
    red: {
      red: '1fa0b4cd-7179-463f-b8fc-05f3133bb8fe',
      red_pg: '',
      red_classic: 'efdd7f80-31b5-4fbb-941e-ae7f52babd09',
      red_basic: '',
      red_gamma: '',
      red_zeta: '1fa0b4cd-7179-463f-b8fc-05f3133bb8fe',
      red_sos: '',
    },
    samli: '5d57aa6d-7a6a-4859-b58a-8090203fe5b2',
    samdt: {
      default: '9fab0aaa-d6a9-406d-b54e-07a1e50b2e75',
      meldcx: 'bba8357f-6020-40ce-b4b0-771640b15917',
    },
    aam: {
      default: 'f6f91b91-ae1a-41c7-992c-896dbf960574',
      vehicle: '1603ad3c-6b81-45f8-92c6-0dbd56be64e5',
      meldcx: '9838532f-38f7-458e-91b6-a4f3dbdc32d9',
    },
    shelfEngagement: 'd71f6575-89ef-4ee6-8d76-45fe99abe382',
    partnerOps: {
      default: 'f2f28926-dce0-4472-a298-96bbc1753b8a',
      starbucksph: '',
      pg: '',
    },
    peopleCounting: '24d71243-1824-4674-bb56-34da1fbb91e2',
    sos: 'adc1901c-71c8-47b1-a2cb-17a764fc0afe',
    prodHopTracking: '9f1177e6-e9f9-4af1-a1b5-6afc70169758',
  }
};

const endpointsDevGcp = {
  environment: 'dev_gcp',
  base_url: 'https://dev-gcp.services.api.viana.ai/',
  base_url_insights: 'https://dev-gcp.insights.api.viana.ai/',
  admin_url: 'https://dev-gcp.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  firebase_config: {
    apiKey: 'AIzaSyCY6zP3geMTZCMeUYbVkgZVzLej-Uj5d-M',
    authDomain: 'prj-dev-svc-viana6e.firebaseapp.com',
    projectId: 'prj-dev-svc-viana6e',
    storageBucket: 'prj-dev-svc-viana6e.firebasestorage.app',
    messagingSenderId: '525981798165',
    appId: '1:525981798165:web:b9c8c428869e189525631c',
    vapidKey: 'BNL6UuKnPGKOBVoGAnLfQrp8PwmbhQFL0RpYG30xD4BdyiiXNe0l9DnO0a6O3OxG0xoV79n3GA7Uo92mtrsMKCQ',
  },

  // sentry_dsn: 'https://3c84de2cf4ef48c8b81d9959fa173ad3@sentry.internal.viana.ai/7'
};

const endpointsDevGcp2 = {
  environment: 'dev_gcp.id2',
  base_url: 'https://viana-services-d-snapper-525981798165.australia-southeast2.run.app/',
  base_url_insights: 'https://crn-viana-dev-ausse2-aiinsights-525981798165.australia-southeast2.run.app/',
  admin_url: 'https://dev-gcp.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  // sentry_dsn: 'https://3c84de2cf4ef48c8b81d9959fa173ad3@sentry.internal.viana.ai/7'
};

const authStagingGCP = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  scope: 'openid user',
  powerBIReportID: '4539fb05-ba4a-4f69-b43b-75b6a48691d9',
  powerBIGroupID: ' 13834247-2464-49f5-b013-b35c254e090a',
  superset: {
    baseUrl: 'https://stg-gcp.superset.internal.viana.ai',
    trafficMeasurement: 'a54b1bd7-28c7-41c8-a2d2-eb1b9d736f9f',
    red: {
      red: '1fa0b4cd-7179-463f-b8fc-05f3133bb8fe',
      red_pg: '',
      red_classic: '9c97fef0-0445-40ad-bc79-03303311988f',
      red_basic: '',
      red_gamma: '',
      red_zeta: '1fa0b4cd-7179-463f-b8fc-05f3133bb8fe',
      red_sos: '',
      red_meldcx: '8d58ca49-2472-409b-9a9f-5a89e7d170b1',
    },
    samli: '5d57aa6d-7a6a-4859-b58a-8090203fe5b2',
    samdt: {
      default: '9fab0aaa-d6a9-406d-b54e-07a1e50b2e75',
      meldcx: '89e3acff-37ad-4948-acf6-278828242e35',
    },
    aam: {
      default: '',
      vehicle: '1603ad3c-6b81-45f8-92c6-0dbd56be64e5',
      meldcx: 'cda4c384-15cd-4a6f-a18f-2821ce0a73ef',
    },
    shelfEngagement: 'a6e93268-0917-4f0f-bb1e-c55a04ce7c20',
    partnerOps: {
      default: '',
      starbucksph: '',
      pg: '',
      meldcx: 'e74ea3e3-5b52-49f5-906a-87830f96a21f',
    },
    peopleCounting: '851471db-3ad4-474d-b05b-185250dfcdf9',
    sos: {
      default: '',
      meldcx: '895450e9-307a-44d1-90e6-07eea1ba9ee9'
    },
    prodHopTracking: '6b7ba9c8-a9eb-440e-9afd-fe298d4bacb8',
  },
  superset2: {
    baseUrl: 'https://v2-stg-gcp.superset.internal.viana.ai',
    aam: {
      default: '',
      vehicle: '',
      meldcx: '57e3d17b-fc31-4265-8e4d-cbdfaca78aab',
      bsign: '6fc0b4da-5b3d-4c9c-9e9d-dd8cb3b1db8c',
    },
  }
};

const endpointsStagingGcp = {
  environment: 'staging_gcp',
  base_url: 'https://viana-services-210498958095.australia-southeast2.run.app/',
  base_url_insights: 'https://viana-insights-210498958095.australia-southeast2.run.app/',
  admin_url: 'https://stg-gcp.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: 'https://3c84de2cf4ef48c8b81d9959fa173ad3@sentry.internal.viana.ai/7',
  firebase_config: {
    apiKey: "AIzaSyAwKHGLQ3xRSUMK8bnG3ooviGvC4WHlrlQ",
    authDomain: "prj-stg-svc-viana-df.firebaseapp.com",
    projectId: "prj-stg-svc-viana-df",
    storageBucket: "prj-stg-svc-viana-df.firebasestorage.app",
    messagingSenderId: "210498958095",
    appId: "1:210498958095:web:99b13429b08969a028847a"
  },
};

export let auth;
if (process.env.REACT_APP_VIANA_ENV === 'production') {
  auth = authProduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'preproduction') {
  auth = authPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'perdue_ppd') {
  auth = authPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'nespresso_ppd') {
  auth = authPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'pc-staging' || process.env.REACT_APP_VIANA_ENV === 'pc-local') {
  auth = authPCStaging;
} else if (process.env.REACT_APP_VIANA_ENV === 'optus' || process.env.REACT_APP_VIANA_ENV === 'optus-local') {
  auth = authOptus;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev') {
  auth = authDev;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev2') {
  auth = authDev;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev4') {
  auth = authDev;
} else if (process.env.REACT_APP_VIANA_ENV === 'node16_dev') {
  auth = authStaging;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging2') {
  auth = authStaging;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging4') {
  auth = authStaging;
}
else if(process.env.REACT_APP_VIANA_ENV === 'versa_dev') {
  auth = authStaging;
}
else if(process.env.REACT_APP_VIANA_ENV === 'versa_staging') {
  auth = authStaging;
}
else if(process.env.REACT_APP_VIANA_ENV === 'viana_lite_internal') {
  auth = authStaging;
}
else if(process.env.REACT_APP_VIANA_ENV === 'viana_lite_internal_preproduction') {
  auth = authPreproduction;
}
else if(process.env.REACT_APP_VIANA_ENV === 'prod2') {
  auth = authProduction;
}
else if(process.env.REACT_APP_VIANA_ENV === 'local') {
  auth = authLocal;
}
else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp') {
  auth = authDevGCP;
}
else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp.id2') {
  auth = authDevGCP2;
}
else if(process.env.REACT_APP_VIANA_ENV === 'staging_gcp') {
  auth = authStagingGCP;
}
else {
  auth = authStaging;
}

export let endpoints;
if (process.env.REACT_APP_VIANA_ENV === 'production') {
  endpoints = endpointsProduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'preproduction') {
  endpoints = endpointsPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'perdue_ppd') {
  endpoints = endpointsPerduePreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'nespresso_ppd') {
  endpoints = endpointsNespressoPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'pc-staging' || process.env.REACT_APP_VIANA_ENV === 'pc-local') {
  endpoints = endpointsPCStaging;
} else if (process.env.REACT_APP_VIANA_ENV === 'optus' || process.env.REACT_APP_VIANA_ENV === 'optus-local') {
  endpoints = endpointsOptus;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev') {
  endpoints = endpointsDev;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev2') {
  endpoints = endpointsDev2;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev3') {
  endpoints = endpointsDev3;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev4') {
  endpoints = endpointsDev4;
} else if (process.env.REACT_APP_VIANA_ENV === 'node16_dev') {
  endpoints = endpointsNode16Dev;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging2') {
  endpoints = endpointsStaging2;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging4') {
  endpoints = endpointsStaging4;
} else if(process.env.REACT_APP_VIANA_ENV === 'versa_dev') {
  endpoints = endpointsVersaDev;
}
else if(process.env.REACT_APP_VIANA_ENV === 'versa_staging') {
  endpoints = endpointsVersaStaging;
}
else if(process.env.REACT_APP_VIANA_ENV === 'viana_lite_internal') {
  endpoints = endpointsVianaLite;
}
else if(process.env.REACT_APP_VIANA_ENV === 'viana_lite_internal_preproduction') {
  endpoints = endpointsVianaLitePreproduction;
}
else if(process.env.REACT_APP_VIANA_ENV === 'prod2') {
  endpoints = endpointsProd2;
}
else if(process.env.REACT_APP_VIANA_ENV === 'local') {
  endpoints = endpointsLocal;
}
else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp') {
  endpoints = endpointsDevGcp;
}
else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp.id2') {
  endpoints = endpointsDevGcp2;
}
else if(process.env.REACT_APP_VIANA_ENV === 'staging_gcp') {
  endpoints = endpointsStagingGcp;
}
else {
  endpoints = endpointsStaging;
}


const initOptions = {
  url: auth.auth_url, realm: auth.realm, clientId: auth.client_id, onLoad: 'login-required'
};


console.log(initOptions)
const keycloak = new Keycloak(initOptions);
export default keycloak;
